import { RefObject, useCallback, useState } from 'react'

type UseContextMenu = {
  sliderContainerRef: RefObject<HTMLDivElement>,
  disabledCtrls: boolean
  canSetInOutPoints: boolean
}

export const useContextMenu = ({ sliderContainerRef, disabledCtrls, canSetInOutPoints }: UseContextMenu) => {
  const [ menuCoords, setMenuCoords ] = useState({ left: 0, top: 0 })
  const [ anchorEl, setAnchorEl ] = useState<HTMLDivElement | null>(null)
  const onOpenMenu = useCallback((e: MouseEvent) => {
    if (anchorEl || disabledCtrls || !canSetInOutPoints) return
    e.preventDefault()
    e.stopPropagation()
    setMenuCoords({ left: e.clientX, top: e.clientY })
    setAnchorEl(sliderContainerRef.current)
  }, [ anchorEl, sliderContainerRef, disabledCtrls, canSetInOutPoints ])

  const onCloseMenu = useCallback((e?: React.SyntheticEvent) => {
    e?.stopPropagation()
    setAnchorEl(null)
    setMenuCoords({ left: 0, top: 0 })
  }, [])

  return {
    onCloseMenu,
    onOpenMenu,
    anchorEl,
    menuCoords,
  }
}
